module.exports = require("./Pagination.vue");